import axios from 'axios';
import WebApiService from '../services/WebApiService';

export default class StackUpService extends WebApiService {

    constructor() {
        super();

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);
    }

    tags(successCallback, errorCallback) {
        this.get('/api/StackUp/Tags', successCallback, errorCallback);
    }

    getUserTagsAndGroups(userId, successCallback, errorCallback) {
        this.get('/api/StackUp/get/user/tags/' + userId, successCallback, errorCallback);
    }

    saveUserTagsAndGroups(data, successCallback, errorCallback) {
        this.post('/api/StackUp/save/user/tags', data, successCallback, errorCallback);
    }

    masterKpis(successCallback, errorCallback) {
        this.get('/api/StackUp/MasterKpis', successCallback, errorCallback);
    }

    stackup(data, successCallback, errorCallback) {
        this.post('/api/StackUp/Data', data, successCallback, errorCallback);
    }

    stackupFree(data, successCallback, errorCallback) {
        this.post('/api/StackUp/DataFree', data, successCallback, errorCallback);
    }
}